var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const defaultCustomStyle = { fontWeight: "normal", fontStyle: "normal", lineHeight: "1.5" };
const defaultPalette = { bgColor: "#ffffff", textColor: "#000000" };
const THEME_DEFAULTS = {
  desktop: {
    customStyles: {
      p: __spreadProps(__spreadValues({}, defaultCustomStyle), {
        fontSize: "16px"
      }),
      h1: __spreadProps(__spreadValues({}, defaultCustomStyle), {
        fontSize: "40px"
      }),
      h2: __spreadProps(__spreadValues({}, defaultCustomStyle), {
        fontSize: "28px"
      }),
      h3: __spreadProps(__spreadValues({}, defaultCustomStyle), {
        fontSize: "24px"
      }),
      h4: __spreadProps(__spreadValues({}, defaultCustomStyle), {
        fontSize: "20px"
      }),
      h5: __spreadProps(__spreadValues({}, defaultCustomStyle), {
        fontSize: "18px"
      }),
      h6: __spreadProps(__spreadValues({}, defaultCustomStyle), {
        fontSize: "16px"
      }),
      quote: {
        lineHeight: "1.5",
        fontSize: "18px"
      },
      codeBlock: {
        lineHeight: "1.5"
      }
    },
    palette: defaultPalette
  },
  mobile: {
    customStyles: {
      p: __spreadProps(__spreadValues({}, defaultCustomStyle), {
        fontSize: "14px"
      }),
      h1: __spreadProps(__spreadValues({}, defaultCustomStyle), {
        fontSize: "32px"
      }),
      h2: __spreadProps(__spreadValues({}, defaultCustomStyle), {
        fontSize: "24px"
      }),
      h3: __spreadProps(__spreadValues({}, defaultCustomStyle), {
        fontSize: "20px"
      }),
      h4: __spreadProps(__spreadValues({}, defaultCustomStyle), {
        fontSize: "20px"
      }),
      h5: __spreadProps(__spreadValues({}, defaultCustomStyle), {
        fontSize: "16px"
      }),
      h6: __spreadProps(__spreadValues({}, defaultCustomStyle), {
        fontSize: "14px"
      })
    },
    palette: defaultPalette
  }
};

export { THEME_DEFAULTS };
//# sourceMappingURL=theme-defaults.js.map
